<template>
    <div>
        <ns-paginate
            class="alert-paginate"
            ref="multipleTable"
            :customFiltersToApply="filterData"
            :listFieldToDisplay="listFieldToDisplay"
            :scoped="$store.getters.userIsAtLeastAdmin ? false : true"
            base-url="alert/"
            :dark="darkMode"
        >
            <template slot="list" slot-scope="props">
                <el-table
                    :data="props.list"
                    style="width: 100%"
                    class="table-alerts"
                    :class="{'dark-theme': darkMode}"
                    @sort-change="sortChange"
                    @selection-change="handleSelectionChange"
                >
                    <template v-for="item in availableFields">
                        <el-table-column
                            v-if="!archived && item.key == 'select'"
                            type="selection"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'name'"
                            :label="getVerbose('alert_table_label_name')"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.name }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'modification_date'"
                            :label="setTimeColumnName"
                            min-width="150"
                            prop="modification_date"
                            sortable
                        >
                            <template slot-scope="scope">
                                {{ scope.row.modification_date | moment('YYYY-MM-DD HH:mm') }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'trigger_count'"
                            :label="getVerbose('alert_table_label_hits')"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.trigger_count }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'level'"
                            :label="getVerbose('alert_table_label_level')"
                            min-width="150"
                            prop="level"
                            :filters="[{text: 'ERROR', value:'ERROR'}, {text: 'WARNING', value:'WARNING'}]"
                            :filter-method="filterHandler"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.level == 'ERROR'">
                                    <i class="el-icon-error text-danger"></i> {{ scope.row.level }}
                                </div>
                                <div v-else>
                                    <i class="el-icon-warning text-warning"></i> {{ scope.row.level }}
                                </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'message'"
                            :label="getVerbose('alert_table_label_message')"
                            min-width="250"
                        >
                            <template slot-scope="scope">
                                <vue-markdown>{{ scope.row.message }}</vue-markdown>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'scopes'"
                            :label="getVerbose('alert_table_label_event')"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                {{ alarmRelatedEntity(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="item.key == 'related_url'"
                            :label="getVerbose('alert_table_label_link')"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    v-tooltip.top="getVerbose('alert_table_redirection_tooltip')"
                                    :disabled="!scope.row.related_url"
                                    icon="ti ti-link"
                                    type="primary"
                                    @click="redirectToResource(scope.row.related_url)"
                                ></el-button>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </template>
        </ns-paginate>
        <div v-if="alertsLength > 0">
            <el-button
                v-if="!acquited"
                type="primary"
                @click="acquitAlert"
            >{{ getVerbose('alert_table_button_acquit') }}</el-button>
            <el-button
                v-if="!archived"
                type="info"
                plain
                @click="archiveAlert"
            >{{ getVerbose('alert_table_button_archive') }}</el-button>
        </div>
    </div>
</template>

<script>
import NsPaginate from '../../partials/nsPaginate2/index.vue';
import VueMarkdown from 'vue-markdown';
import {mapGetters} from 'vuex';
export default {
    components: {
        NsPaginate,
        VueMarkdown,
    },

    props: {

        alertsLength: {
            type: Number,
            required: true,
        },

        acquited: {
            type: Boolean,
            required: true,
        },

        archived: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {
            multipleSelection: [],
            listFieldToDisplay: [
                {
                    key: 'select',
                    verbose: 'Select',
                },
                {
                    key: 'name',
                    verbose: 'Name',
                },
                {
                    key: 'modification_date',
                    verbose: 'Last trigger',
                },
                {
                    key: 'trigger_count',
                    verbose: 'Nb of triggers',
                },
                {
                    key: 'level',
                    verbose: 'Level',
                },
                {
                    key: 'message',
                    verbose: 'Message',
                },
                {
                    key: 'scopes',
                    verbose: 'Event',
                },
                {
                    key: 'related_url',
                    verbose: 'Link to resource',
                },
            ],
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getCorrectRelatedUrl',
            'getVerbose',
            'alertFieldsToHide',
            'darkMode'
        ]),
        setTimeColumnName() {
            return this.acquited ? this.getVerbose('alert_table_label_acquitted') : this.getVerbose('alert_table_label_triggered');
        },

        filterData() {
            return () => {
                return {acquited: new Boolean(this.acquited).toString(), archived: new Boolean(this.archived).toString()};
            };
        },
        availableFields (){
            let fields = [];
            for (let item of this.listFieldToDisplay){
                if(!this.alertFieldsToHide.includes(item.key)){
                    fields.push(item);
                }
            }
            return fields;
        },

    },

    updated() {
        this.$refs.multipleTable.loadContent();
    },

    methods: {

        sortChange(sortValue) {
            let sign = '';
            if (sortValue.order === 'descending') sign = '-';
            this.$refs.multipleTable.loadContent(null, {
                'ordering': `${sign}${sortValue.prop}`
            });
        },

        redirectToResource (related_url){
            window.location.href=this.getCorrectRelatedUrl(related_url);
        },

        alarmRelatedEntity (alarm){
            try{
                return this.$store.getters.projectsByUid(alarm.scopes.entity_uid).verbose_name;
            }catch(e){
                return this.getVerbose('alert_table_event_not_found');
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },

        acquitAlert() {
            this.$confirm(
                this.getVerbose('alert_acquit_modal_text'),
                this.getVerbose('alert_acquit_modal_title'),
                {
                    confirmButtonText: this.getVerbose('alert_acquit_modal_button_confirm'),
                    cancelButtonText: this.getVerbose('alert_acquit_modal_button_cancel'),
                    type: 'warning',
                }
            ).then(() => {
                let promises  = [];
                for(let alert of this.multipleSelection) {
                    promises.push(this.$store.dispatch('patchItem', {
                        item: {
                            url: alert.url,
                            uid: alert.uid,
                            acquited: true,
                        },
                        model: 'alerts',
                    }));
                }
                Promise.all(promises).then(() => {
                    this.$message({
                        type: 'success',
                        message: this.getVerbose('alert_acquit_sucessfull')
                    });
                    this.$refs.multipleTable.loadContent();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.getVerbose('alert_acquit_failed')
                });
            });
        },

        archiveAlert() {
            this.$confirm(this.getVerbose('alert_archive_modal_text'), this.getVerbose('alert_archive_modal_title'), {
                confirmButtonText: this.getVerbose('alert_archive_modal_button_confirm'),
                cancelButtonText: this.getVerbose('alert_archive_modal_button_cancel'),
                type: 'warning',
            }).then(() => {
                let promises  = [];
                for(let alert of this.multipleSelection) {
                    promises.push(this.$store.dispatch('patchItem', {
                        item: {
                            url: alert.url,
                            uid: alert.uid,
                            acquited: true,
                            archived: true,
                        },
                        model: 'alerts',
                    }));
                }

                Promise.all(promises).then(() => {
                    this.$message({
                        type: 'success',
                        message: this.getVerbose('alert_archive_sucessfull')
                    });
                    this.$refs.multipleTable.loadContent();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.getVerbose('alert_archive_failed')
                });
            });
        },
    }
};
</script>

<style lang="scss">

.alert-paginate {
    .list-container {
        padding: 0 0 30px 0;
    }
}

.table-alerts {
    margin-bottom: 20px;
    &.dark-theme {
        .el-loading-mask {
            background-color: rgba(82, 82, 82, .9);
        }
        .el-table__empty-block {
            background-color: #2E3035;
            color: #EAEBEF;
        }
        &::before {
            background-color: #2E3035;
        }
        .el-table__header-wrapper {
            background-color: #57595D;
            border-bottom: 1px solid #393B40;
        }
        thead {
            tr {
                th {
                    color: #EAEBEF;
                    background-color: #57595D;
                    border: none;
                }
            }
        }
        .el-table__row {
            td {
                color: #EAEBEF;
                background-color: #2E3035;
                border-color: #393B40;
            }
            &:hover {
                td {
                    background-color: #37393D;
                }
            }
        }
    }
}

.el-table {
    .cell {
        word-break: break-word;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/alerts/AlertsTable.vue